module.exports = __webpack_public_path__ + "static/media/logo-dp-on-tp.e42092cd.svg";